var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quality-filter',{on:{"change":_vm.onChange}}),_c('br'),_c('quality-online-data',{attrs:{"filter-form":_vm.filterForm}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }